import React from 'react';

import Hero from 'components/Hero';
import SpaceCardsList from 'components/SpaceCardsList';
import UpcomingEvents from 'components/Events/components/UpcomingEvents';
import HomePosts from 'components/HomePosts/HomePosts';
import CommunityChecklist from 'components/CommunityChecklist';
import { SCREEN_LG } from 'utils/constants';
import { useWindowSize } from 'hooks/useWindowSize';
import VisibilityCloak from 'components/VisibilityCloak/VisibilityCloak';
import FeatureCloak from 'components/VisibilityHelpers/FeatureCloak';
import CreateNewPost from 'components/CreateNewPost';

interface HomeFeedProps {
  community: {
    published: boolean;
    primaryColor: string;
    description: string;
    imageUrl?: string;
    name: string;
  };
  postListState: {
    useCacheFirst: boolean;
  };
}

const HomeFeed = ({ community, postListState }: HomeFeedProps) => {
  const { width } = useWindowSize();
  const isTabletOrSmaller = width < SCREEN_LG;

  const shouldShowCommunitiesChecklist =
    !community.published && isTabletOrSmaller;

  return (
    <>
      <Hero
        description={community.description}
        src={community.imageUrl}
        title={community.name}
      />
      <CreateNewPost />
      {shouldShowCommunitiesChecklist && (
        <VisibilityCloak admins>
          <CommunityChecklist />
        </VisibilityCloak>
      )}
      <FeatureCloak communityEvents>
        <UpcomingEvents />
      </FeatureCloak>

      <HomePosts postListState={postListState} />

      <SpaceCardsList />
    </>
  );
};

export default HomeFeed;
